import { ArrowSplitHorizontalIcon } from './ArrowSplitHorizontalIcon';

/**
 * author: Michael Richins
 * id ED7981BC-0B25-4657-BB7C-FB14A3D91D99
 * name arrow-split-horizontal
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-split-horizontal.svg
 * tags
 * - Arrow 
 */
export const ResizeVerticalIcon = ArrowSplitHorizontalIcon;
export default ResizeVerticalIcon